'use strict';

angular.module('studies')
    .component('studyCreationForm', {
        templateUrl: 'js/modules/studies/components/creation-form/template.html',
        controller: 'StudyCreationFormController',
        bindings: {
            'onSubmit': '&',
        },
    });
